module.exports = __webpack_public_path__ + "330faf0f676f455dcb70e30811095986.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/zgzyyb_c.png
// module id = 276
// module chunks = 3